export default {"src":"/_next/static/media/download-icon.6645f1d6.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};